<div class="bg-white overflow-hidden shadow sm:rounded-lg file-uploader-container">
    <div>
        <div class="border-b border-b-gray-300 zuper-dialog-header" *ngIf="data?.data?.header?.isHeader || false">
            <!-- Content goes here -->
            <div class="flex justify-between">
              <h6 mat-dialog-title class="font-semibold primary-font">{{data?.data?.header?.headerTitle ?
                data?.data?.header?.headerTitle : (data?.data?.header?.headerDisplayKey ? (data?.data?.header?.headerDisplayKey | translate) : data?.data?.header?.headerDisplayName || "Upload Attachments")
                }} </h6>
            </div>
            <!-- Dropdown and Dismiss button -->
            <div class="flex items-center ml-auto">
              @if(selectedVisibilityDropdown){
                <div class="flex items-center w-full">
                  <brn-select class="w-full" placeholder="{{ 'text.choose_option' | translate }}" [(ngModel)]='selectedUserVisibility' (ngModelChange)="onVisibilityChange($event)">
                    <hlm-select-trigger class="w-full h-10 primary-font">
                      <div class="flex items-center w-full">
                        <em class="ti icon-size-5 mr-3 mb-1" [ngClass]="{'ti-world': selectedUserVisibility === true, 'ti-users': selectedUserVisibility == false}"></em>
                        <hlm-select-value class="text-base font-medium"></hlm-select-value>
                      </div>
                    </hlm-select-trigger>
                    <hlm-select-content class="max-h-96 min-w-40 overflow-auto settings-scroll">
                        @if(userVisibilities.length > 0) {
                            @for(item of userVisibilities; track $index) {
                                <hlm-option class="text-base hide-check" [value]="item?.value">
                                  <div class="flex items-center">
                                    <em class="ti icon-size-5 mr-3 mb-1" [ngClass]="{'ti-world': item.value === true, 'ti-users': item.value == false}"></em>
                                    {{ item?.label | translate }}
                                  </div>
                                </hlm-option>
                            }
                        }
                    </hlm-select-content>
                  </brn-select>
                </div>
              }                
              <div class="ml-4" *ngIf="uploader?.progress === 0 || uploader?.progress === 100">
                <span mat-dialog-close class="rounded-full flex justify-center items-center hover:bg-gray-200 h-9 w-9 p-2 cursor-pointer">
                  <em class="ti ti-x text-xl font-bold"></em>
                </span>
              </div>
            </div>
        </div>
        <div class="file-modal-body zuper-scrollbar p-6" [ngClass]="{'pt-4': (data?.data?.showProgress || data?.data?.showPreview)}">
          <div>
            <p class="text-red-500 py-1 ml-auto text-base" *ngIf="data?.data?.multiple && data?.data?.setMaxLimit">*
              {{'attachment.file_uploader.max_attach.alert' | translate}} : {{companyPolicy?.attachments?.max_no_of_attachments ??
              0}}</p>
            <div class="flex justify-center items-center w-full"
            ng2FileDrop
            (onFileDrop)="fileDrop()"
            [uploader]="uploader"
            >
                <label for="dropzone-file" class="flex flex-col justify-center items-center w-full h-64 bg-gray-50 rounded-lg border-2 border-gray-300 border-dashed dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
                [ngClass]="{'cursor-not-allowed':disableUpload, 'cursor-pointer': !disableUpload}">
                    <div class="flex flex-col justify-center items-center pt-5 pb-6">
                        <svg class="mb-3 w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path></svg>
                        <p class="mb-2 text-sm text-gray-500 dark:text-gray-400"><span class="font-semibold">{{'text.click_to_upload' | translate}}</span> {{'text.drag_and_drop' | translate}}</p>
                        <p class="text-xs text-gray-500 dark:text-gray-400">{{data?.data?.description?.descriptionKey ? (data?.data?.description?.descriptionKey | translate) : data?.data?.description?.descriptionName}}</p>
                        <p class="text-sm mt-2 text-red-500 dark:text-red-400" *ngIf="companyPolicy?.attachments?.max_attachment_size">* {{'maximum.file.size.text' | translate }} : {{(companyPolicy?.attachments?.max_attachment_size)}} MB</p>
                    </div>
                    <input id="dropzone-file" type="file" ng2FileSelect [accept]="data?.data?.acceptedFileFormat ?? ''" (onFileSelected)="fileDrop()" [multiple]="data.data.multiple"
                    [uploader]="uploader" [disabled]="disableUpload"
                    class="hidden" />
                </label>
            </div> 
          </div>
          <div class="w-full bg-gray-200 rounded-full dark:bg-gray-700 mt-3" *ngIf="data?.data?.showProgress && uploader?.queue?.length > 0 && data?.data?.multiple">
              <div class="bg-blue-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full" [ngStyle]="getProgress(uploader?.progress)"> {{uploader?.progress}}%</div>
          </div>
          <div class="rounded-md bg-blue-50 p-4 mt-2" *ngIf="!data?.data?.multiple">
              <div class="flex">
                <div class="flex-shrink-0">
                  <!-- Heroicon name: solid/information-circle -->
                  <svg class="h-5 w-5 text-blue-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
                  </svg>
                </div>
                <div class="ml-3 flex-1 md:flex md:justify-between">
                  <p class="text-sm text-blue-700">{{"attachment.file_uploader.note" | translate}}: {{"attachment.file_uploader.only_one_attachment_allowed" | translate}}</p>
                </div>
              </div>
            </div>
          <mat-expansion-panel [expanded]="data?.data?.multiple === false" class="mt-3" *ngIf="uploader?.queue?.length > 0 && data?.data?.uploadDetails">
              <mat-expansion-panel-header>
                {{"attachment.file_uploader.table.upload_details" | translate}}
              </mat-expansion-panel-header>
              <div class="overflow-y-auto border-t border-gray-300 mt-5" style="max-height: 36vh">
                  <table mat-table [dataSource]="dataSource" class="file-table">
                      <!-- Position Column -->
                      <ng-container matColumnDef="position">
                        <th mat-header-cell *matHeaderCellDef>{{"attachment.file_uploader.table.no" | translate}}</th>
                        <td mat-cell *matCellDef="let element; let i = index" class="w-1/12">
                          <div class="primary-font text-base">{{i+1}}</div>
                        </td>
                      </ng-container>
                    
                      <!-- File Name Column -->
                      <ng-container matColumnDef="file_name">
                        <th mat-header-cell *matHeaderCellDef class="px-4">{{"attachment.file_uploader.table.file_name" | translate}}</th>
                        <td mat-cell *matCellDef="let element" class="w-5/12 px-4">
                          <div class="primary-font text-base">{{element?.file?.name}}</div>
                        </td>
                      </ng-container>
                    
                      <!-- Size Column -->
                      <ng-container matColumnDef="size">
                        <th mat-header-cell *matHeaderCellDef class="px-2">{{"text.size" | translate}}</th>
                        <td mat-cell *matCellDef="let element" class="w-2/12 px-2">
                          <div class="primary-font text-base">{{element?.file?.size ? _utilityService.getFileSize(element.file.size) : '0 Byte'}}</div>
                        </td>
                      </ng-container>
                    
                      <!-- Progress Column -->
                      <ng-container matColumnDef="progress">
                        <th mat-header-cell *matHeaderCellDef class="px-2">{{"status.sync_history.progress" | translate}}</th>
                        <td mat-cell *matCellDef="let element" class="w-3/12 px-2"> 
                          <div class="w-3/4 bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                              <div class="bg-blue-600 h-2.5 rounded-full" [ngStyle]="getProgress(element.progress)"></div>
                          </div>    
                        </td>
                      </ng-container>
      
                      <!-- Actions Column -->
                      <ng-container matColumnDef="actions">
                          <th mat-header-cell *matHeaderCellDef class="text-center">{{"actions.text" | translate}}</th>
                          <td mat-cell *matCellDef="let element; let i= index" class="text-center w-1/12"> 
                              <button matTooltip='{{"attachment.file_uploader.table.tooltip.remove_file" | translate}}' (click)="removeFile(i)"  class="inline-flex items-center p-1 border border-transparent shadow text-black bg-gray-100 hover:bg-gray-300 focus:outline-none focus:ring-white-500">
                                  <i class="ti ti-trash"></i>
                              </button>    
                          </td>
                      </ng-container>
                    
                      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
                      <tr
                          mat-row
                          *matRowDef="let row; columns: displayedColumns;"
                      ></tr>
                    </table>
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel [expanded]="data?.data?.showPreview !== false && preview_data.length > 0" class="mt-3" *ngIf="data?.data?.showPreview !== false  && preview_data.length > 0">
              <mat-expansion-panel-header>
                {{"attachment.file_uploader.preview_attachments" | translate}}
                <badge [options]="getPreviewCountOptions()" class="ml-2 primary-font"></badge>
              </mat-expansion-panel-header>
              <div class="flex flex-wrap">
                <ng-container *ngFor="let attachment of preview_data; let i=index">
                    <file-placeholder class="my-2 pr-4 file-placeholder"
                    [options]="getPlaceholderOptions(attachment, true, false)"
                    (fileEventEmitter)="fileEventEmitHandler($event, i)"
                    >
                    </file-placeholder>
                </ng-container>
            </div>
            </mat-expansion-panel>
        </div>
        <div *ngIf="data?.data?.submit?.isSubmit || data?.data?.close?.isClose" class="text-right border-gray-300 border-t zuper-dialog-footer">
            <button type="button" *ngIf="data?.data?.close?.isClose" mat-dialog-close class="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none mr-2">{{data?.data?.close?.closeDisplayKey ? (data?.data?.close?.closeDisplayKey | translate) : data?.data?.close?.closeDisplayName || "Close"}}</button>
            <button type="button" *ngIf="data?.data?.submit?.isSubmit" [disabled]="preview_data.length === 0" (click)="submitClicked()" class="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary focus:outline-none" [ngClass]="{'opacity-50':preview_data.length === 0,'cursor-not-allowed':preview_data.length === 0}">{{data?.data?.submit?.submitDisplayKey ? (data?.data?.submit?.submitDisplayKey | translate) : data?.data?.submit?.submitDisplayName || "Submit"}}</button>
        </div>
    </div>
</div>